<template>
  <div class="base_modal_apelido" v-if="isOpen">
    <div class="modal_apelido">
      <h1>ALTERAR NOME DE USUÁRIO</h1>
      <span>
        <label for="apelido_atual" class="label-titulo">Nome de usuário atual</label>
        <input class="input-form" :value="dados.nm_apelido" id="apelido_atual" readonly>
      </span>
      <span>
        <label for="novo_apelido" class="label-titulo">Novo nome de usuário</label>
        <input
            class="input-form"
            :class="{ 'input-erro': apelidoInvalido }"
            v-model="nm_apelido"
            @input="formatarApelido"
            @blur="validarApelido"
            placeholder="INSIRA SEU NOVO NOME DE USUÁRIO"
            required
            id="novo_apelido"
            maxlength="15"
        />
        <span v-if="apelidoInvalido" class="mensagem-erro">{{ apelidoInvalido }}</span>
      </span>
      <div class="base_botao_apelido">
        <Botao btn_text="SALVAR ALTERAÇÃO" @click="salvarNovoApelido($event)"/>
        <Botao btn_text="FECHAR" @click="fecharModal"/>
      </div>
    </div>
  </div>
</template>

<script>
import Botao from "@/components/shared/Botao.vue";
import {limparApelido} from "@/domain/limpaEspacacoCaracteresEspeciais";
import {AlteraApelido} from "@/controllers/altera-apelido";

export default {
  name: 'ModalApelido',
  components: {Botao},
  props: ['dados', 'isOpen'],
  data() {
    return {
      nm_apelido: '',
      apelidoInvalido: '',
      apelidoAtual: ''
    }
  },
  methods: {
    formatarApelido() {
      this.nm_apelido = limparApelido(this.nm_apelido);
      this.apelidoInvalido = '';
    },

    validarApelido() {
      if (!this.nm_apelido || this.nm_apelido.length < 3 || this.nm_apelido.length > 15) {
        this.apelidoInvalido = 'Apelido deve ter entre 3 e 15 caracteres.';
      } else {
        this.apelidoInvalido = '';
      }
    },
    limparApelido,
    fecharModal() {
      this.$emit('close');
    },
    async salvarNovoApelido(e) {
      try {
        e.preventDefault();
        this.validarApelido();

        if (this.apelidoInvalido) return;

        const data = {
          nm_apelido: this.nm_apelido
        };

        await AlteraApelido(data);
        alert('Apelido alterado com sucesso!');

        setTimeout(() => {
          window.location.reload();
        }, 3000);

      } catch (e) {
        alert(e.message);
      }
    }
  },
  watch: {
    isOpen(val) {
      if (val) {
        this.apelidoAtual = this.dados.nm_apelido;
      }
    }
  },
}
</script>

<style scoped>
.base_botao_apelido {
  display: flex;
  justify-content: space-between;
}

.base_modal_apelido {
  width: 100%;
  top: 0;
  left: 0;
  height: 100%;
  position: fixed;
  background: #ffffff00;
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
}

.modal_apelido span {
  display: flex;
  flex-direction: column;
  margin-bottom: 5px;
}

.modal_apelido h1 {
  text-align: center;
  color: #444;
  font-size: 24px;
}

.modal_apelido {
  width: 500px;
  min-height: 300px;
  background: #fff;
  display: flex;
  flex-direction: column;
  padding: 25px;
  border-radius: 4px;
  box-shadow: 0 0 10px #c7c7c7;
}

.modal_apelido .input-form {
  border-radius: 3px 3px 0 0;
  border: none;
  border-bottom: 3px solid var(--bd-primary);
  background: var(--bd-inputs-gerais);
  color: var(--color-label-forms);
  font-size: 16px;
  padding: 8px 10px !important;
  line-height: initial !important;
}

.input-erro {
  border-bottom: 3px solid red !important;
  background-color: #ffe6e6;
}

.mensagem-erro {
  color: red;
  font-size: 14px;
  margin-top: 5px;
}
</style>
